import React from 'react';
import { Stack } from '../../design-system/stack/stack';
import ConsentSettings from './consent-settings';

const OrganisationSettingsPage: React.FC = () => {
  return (
    <Stack align="stretch" className="min-h-full flex-1 py-2 pr-2">
      <Stack align="stretch" className="flex-1 rounded-md border border-border bg-background shadow-xs">
        <div className="px-5 pt-5 pb-4">
          <h1 className="text-2xl font-semibold text-gray-900">Organisation Settings</h1>
          <p className="mt-1 text-sm text-gray-500">Manage your data sharing consents with third-party providers.</p>
        </div>

        <ConsentSettings />
      </Stack>
    </Stack>
  );
};

export default OrganisationSettingsPage;
